import React from 'react';

const Question = (props) => {
    return (
        <h2>
            {props.question}
        </h2>
    );
};

export default Question;